import { Component, Input, OnInit } from '@angular/core';
import get from 'lodash-es/get';

import { IPicture } from '@finder/shared/components/picture/picture.interface';

@Component({
    selector: 'finder-dfm',
    templateUrl: './dfm.component.html',
    styleUrls: ['./dfm.component.scss']
})
export class DfmComponent implements OnInit {

    @Input() dfmData: any;

    public dfmImage: IPicture;

    constructor() { }

    ngOnInit() {
        this.dfmImage = this.getImageData();
    }

    getImageData(): IPicture | undefined {
        let imageData: IPicture;

        if (get(this.dfmData, 'image')) {
            imageData = {
                mobile: this.dfmData.image.url,
                desktop: this.dfmData.image.url,
                media: get(this.dfmData.image, 'media', ''),
                alt: this.dfmData.image.alt
            };
        }

        return imageData;
    }
}
